import React, { useEffect, useState } from "react";
import { Row, Col, Card, Form, Button, Table } from "react-bootstrap";
import ReactQuill from "react-quill";
import Select from "react-select";
import { useParams, useNavigate } from "react-router-dom";
import swal from "sweetalert";
import api from "../../../api";
import "react-quill/dist/quill.snow.css";

const TestCertificates = () => {

const { id } = useParams();
const navigate = useNavigate();

const [products,setProducts]=useState([]);
const [client,setClient]=useState("");
const [refNo,setRefNo]=useState("");

const [rows,setRows]=useState([]);
const [subject,setSubject]=useState("");
const [topContent,setTopContent]=useState("");
const [bottomContent,setBottomContent]=useState("");
const [status, setStatus] = useState("Draft");
const [certificateDate, setCertificateDate] = useState("");

/* ================= FETCH DATA ================= */

useEffect(()=>{
fetchProducts();
},[]);

useEffect(()=>{
if(id && products.length){
fetchCertificate();
}
},[products]);


/* ================= PRODUCTS ================= */

const fetchProducts = async()=>{

const res = await api.get("/products");

if(res.data.success){
setProducts(res.data.data);
}

};





/* ================= FETCH CERTIFICATE ================= */

const fetchCertificate = async()=>{

const res = await api.get(`/test-certificates/${id}`);

if(res.data.success){

const cert = res.data.data;

setClient(cert.client || "");
setRefNo(cert.refNo || "");

setSubject(cert.subject || "");
setTopContent(cert.topContent || "");
setBottomContent(cert.bottomContent || "");
setStatus(cert.status || "Draft");
setCertificateDate(
 cert.certificateDate
 ? new Date(cert.certificateDate).toISOString().split("T")[0]
 : ""
);

const formattedRows = cert.items.map(item => ({
product: item.product,
productOption: {
value: item.product,
label: item.productName
},
productName: item.productName,
modelNo: item.modelNo,
qty: item.qty,
serialFrom: item.serialFrom,
serialTo: item.serialTo
}));

setRows(formattedRows);

}

};



const productOptions = products.map(p => ({
value: p._id,
label: `${p.productName} (${p.modelNo})`,
productName: p.productName,
modelNo: p.modelNo
}));


/* ================= ADD ROW ================= */

const addRow = ()=>{
 

setRows([
...rows,
{
product:null,
productOption:null,
productName:"",
modelNo:"",
qty:"",
serialFrom:"",
serialTo:""
}
]);

};


/* ================= ROW CHANGE ================= */
const removeRow = (index) => {
 const newRows = rows.filter((_, i) => i !== index);
 setRows(newRows);
};
const handleRowChange = (index,field,value)=>{

const newRows=[...rows];
if(field==="product"){

newRows[index].product = value.value;
newRows[index].productOption = value;
newRows[index].productName = value.productName;
newRows[index].modelNo = value.modelNo;

}else{

newRows[index][field]=value;

}

/* auto calculate qty only when serial fields change */
if (field === "serialFrom" || field === "serialTo") {
 const from = newRows[index].serialFrom;
 const to = newRows[index].serialTo;

 if (from && to) {
 const fromNums = from.match(/\d+/g);
 const toNums = to.match(/\d+/g);

 if (fromNums && toNums && fromNums.length === toNums.length) {
 let diffIdx = -1;
 for (let i = 0; i < fromNums.length; i++) {
 if (fromNums[i] !== toNums[i]) {
 diffIdx = i;
 }
 }

 if (diffIdx !== -1) {
 const startNumStr = fromNums[diffIdx];
 const endNumStr = toNums[diffIdx];
 const start = parseInt(startNumStr);
 const end = parseInt(endNumStr);
 if (!isNaN(start) && !isNaN(end)) {
 newRows[index].qty = end - start + 1;
 }
 }
 }
 }
}

setRows(newRows);

};


const generateSerialNumbers = (from, to) => {
 if (!from || !to) return "";

 // Find all numeric sequences in both strings
 const fromNums = from.match(/\d+/g);
 const toNums = to.match(/\d+/g);

 if (!fromNums || !toNums || fromNums.length !== toNums.length) {
 return from === to ? from : `${from} to ${to}`;
 }

 // Find the last index where they differ (usually the incrementing serial part)
 let diffIdx = -1;
 for (let i = 0; i < fromNums.length; i++) {
 if (fromNums[i] !== toNums[i]) {
 diffIdx = i;
 }
 }

 // If no difference found, just return the string
 if (diffIdx === -1) return from;

 const startNumStr = fromNums[diffIdx];
 const endNumStr = toNums[diffIdx];
 const start = parseInt(startNumStr);
 const end = parseInt(endNumStr);

 if (isNaN(start) || isNaN(end) || start > end) {
 return `${from} to ${to}`;
 }

 // Create a template by replacing the differing number with a placeholder
 // We use a unique marker that won't exist in the string
 let count = 0;
 const template = from.replace(/\d+/g, (match) => {
 if (count++ === diffIdx) return "__SERIAL__";
 return match;
 });

 const padding = startNumStr.length;
 let arr = [];
 
 // Limit to a reasonable number to avoid UI lag (e.g., 500)
 const maxSerials = Math.min(end, start + 500);
 
 for (let i = start; i <= maxSerials; i++) {
 const currentNumStr = String(i).padStart(padding, '0');
 arr.push(template.replace("__SERIAL__", currentNumStr));
 }

 if (end > start + 500) {
 arr.push("...");
 }

 return arr.join(", ");
};


/* ================= SAVE CERTIFICATE ================= */

const saveCertificate = async()=>{

const payload={
client,
refNo,

subject,
certificateDate,
topContent,
bottomContent,
status,
items: rows.map(r=>({
product:r.product,
productName:r.productName,
modelNo:r.modelNo,
qty:r.qty,
serialFrom:r.serialFrom,
serialTo:r.serialTo
}))
};

try{

if(id){

await api.put(`/test-certificates/${id}`,payload);
swal("Updated","Certificate updated successfully","success");

}else{

await api.post("/test-certificates",payload);
swal("Saved","Certificate created successfully","success");

}

navigate("/test-certificates-list");

}catch(err){

console.error(err);
swal("Error","Failed to save certificate","error");

}

};





/* ================= UI ================= */

return (

<Row>

<Col lg={12}>

<Card>

<Card.Header className="d-flex justify-content-between">

<h4>{id ? "Edit Test Certificate" : "Add Test Certificate"}</h4>

<Button
variant="secondary"
onClick={()=>navigate("/test-certificates-list")}
>
Back
</Button>

</Card.Header>

<Card.Body>

{/* CLIENT */}

<Form.Group className="mb-3">
<Form.Label>Client</Form.Label>
<Form.Control
as="textarea"
rows={3}
value={client}
onChange={(e)=>setClient(e.target.value)}
placeholder="Enter Client Name"
/>
</Form.Group>

{/* DATE */}

<Form.Group className="mb-3">
 <Form.Label>Certificate Date</Form.Label>

 <Form.Control
 type="date"
 value={certificateDate}
 onChange={(e) => setCertificateDate(e.target.value)}
 />

</Form.Group>
<Form.Group className="mb-3">

<Form.Label>Reference (Ref)</Form.Label>

<Form.Control
value={refNo}
onChange={(e)=>setRefNo(e.target.value)}
placeholder="Enter Reference"
/>

</Form.Group>

{/* SUBJECT */}

<Form.Group className="mb-3">

<Form.Label>Subject</Form.Label>

<Form.Control
value={subject}
onChange={(e)=>setSubject(e.target.value)}
placeholder="Enter Subject"
/>

</Form.Group>

{/* STATUS */}
<Form.Group className="mb-3">
 <Form.Label>Status</Form.Label>
 <Form.Select
 value={status}
 onChange={(e) => setStatus(e.target.value)}
 >
 <option value="Draft">Draft</option>
 <option value="Pending">Pending</option>
 </Form.Select>
</Form.Group>


{/* CONTENT */}

<Form.Group className="mb-4">

<Form.Label>Certificate Content</Form.Label>

<ReactQuill
value={topContent}
onChange={setTopContent}
/>

</Form.Group>


{/* PRODUCTS TABLE */}

<div style={{ overflowX: "auto", minHeight: "350px" }}>

<Table
bordered
className="test-certificate-table"
style={{ minWidth: "1600px" }}
>

<thead style={{ backgroundColor: "#ffd0a7" }}>

<tr>

<th>SR.NO</th>
<th>QTY</th>
<th>PRODUCT NAME</th>
<th>MODEL NUMBER</th>
<th>Serial From</th>
<th>Serial To</th>
<th>Generated Serials</th>
<th>Action</th>

</tr>

</thead>


<tbody>

{rows.map((row,index)=>(
<tr key={index} style={{ backgroundColor: index % 2 === 0 ? "#bae8ff" : "#ffffff" }}>

<td>{index+1}</td>

<td>

<Form.Control
style={{width:"70px"}}
value={row.qty}
onChange={(e)=>handleRowChange(index,"qty",e.target.value)}
/>

</td>

<td style={{minWidth:"350px"}}>

<Select
options={productOptions}
value={row.productOption}
onChange={(selected)=>handleRowChange(index,"product",selected)}
placeholder="Select Product"
/>

</td>

<td>

<Form.Control
value={row.modelNo}
readOnly
/>

</td>

<td style={{ minWidth: "200px" }}>

<Form.Control
value={row.serialFrom}
onChange={(e)=>handleRowChange(index,"serialFrom",e.target.value)}
/>

</td>

<td style={{ minWidth: "200px" }}>

<Form.Control
value={row.serialTo}
onChange={(e)=>handleRowChange(index,"serialTo",e.target.value)}
/>

</td>

<td style={{ minWidth: "450px", fontSize: "12px" }}>
{generateSerialNumbers(row.serialFrom,row.serialTo)}

</td>
<td>

<Button
variant="danger"
size="sm"
onClick={() => removeRow(index)}
>
Remove
</Button>

</td>

</tr>
))}

</tbody>

</Table>
</div>

<Button onClick={addRow} className="me-3">
Add Product
</Button>

<Button variant="success" onClick={saveCertificate} className="me-3">
{id ? "Update Certificate" : "Save Certificate"}
</Button>




{/* FOOTER */}

<Form.Group className="mt-4">

<Form.Label>Footer Content</Form.Label>

<ReactQuill
value={bottomContent}
onChange={setBottomContent}
/>

</Form.Group>

</Card.Body>

</Card>

</Col>

</Row>

);

};

export default TestCertificates;